import {Component, OnInit, Input, AfterViewInit, Output, EventEmitter} from '@angular/core';
import {ChannelOpportunityItem, ReportSectionEnum} from '../../../../../models/measure/report';
import {PdfExportService} from '../../../../services/export-pdf/pdf-export.service';
import {UserService} from '../../../../services/user.service';
import {CommonConstant, defaultPlatformSettings} from '../../../../app.constants';

enum TextData {
  NA = 'NA',
}

enum Vertical {
  Index = 2
}

@Component({
  selector: 'channel-opportunities-report',
  templateUrl: './channel-opportunities-report.component.html',
  styleUrls: ['./channel-opportunities-report.component.scss']
})
export class ChannelOpportunitiesReportComponent implements OnInit, AfterViewInit {
  static COMPONENT_NAME = 'ChannelOpportunitiesReportComponent';
  @Input() data: Array<Array<ChannelOpportunityItem>>;
  @Input() period: number;
  @Input() public industryIndex: number;
  @Output() public changeSettingEvent: EventEmitter<any> = new EventEmitter<any>();
  public industryList: Array<{id: number, name: string}>;
  public opportunityData: Array<ChannelOpportunityItem> = [];
  public isNoData: boolean;
  constructor(private pdfService: PdfExportService, private userService: UserService) { }

  ngOnInit() {
    this.isNoData = false;
    if (this.data && this.data.length === 0) {
      this.isNoData = true;
      return;
    }
    // get industry list
    if (this.data) {
      this.industryList = this.data
        .map((channel, index) => (
          {
            id: index,
            name: channel[Vertical.Index].verticalName
          }
        ))
        .filter(channel => channel.name !== TextData.NA);

      if (this.industryIndex) {
        this.selectIndustry(this.industryIndex);
      } else if (this.industryList.length > 0) {
        this.industryIndex = this.industryList[0].id;
        this.selectIndustry(this.industryIndex);
      }
    }
  }

  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady(ChannelOpportunitiesReportComponent.COMPONENT_NAME);
  }

  public selectIndustry(industryIndex) {
    if (industryIndex === null) {
      this.opportunityData = [];
    } else {
      this.opportunityData = this.data[industryIndex].slice(0, 2);
      this.changeSettingEvent.emit({
        reportType: ReportSectionEnum.INSIGHT_OPPORTUNITY_REPORT,
        value: industryIndex
      });
    }
  }

  // calculate percent and return if percent is bigger than 100
  public calculatePercent(percent) {
    return percent > 100 ? 100 : percent;
  }

  get isExportingPdfReport() {
    return this.pdfService.exportingPdf;
  }

  get reachLineColor() {
    return defaultPlatformSettings.chartColors[1];
  }

  get engageLineColor() {
    return defaultPlatformSettings.chartColors[2];
  }

}



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/channel-opportunities-report/channel-opportunities-report.component.ts